import request from "./request";

// 手机号验证码登录
export function captchaLogin(data){
    return request({
      url: 'org/Login/captchaLogin',
      method: 'post',
      data:data
    })
}

// 手机号验证码登录--模拟卷
export function captchaLoginMockTest(data){
  return request({
    url: 'org/Login/captchaLoginMockTest',
    method: 'post',
    data:data
  })
}

// 用户名或手机号登录
export function passwordLogin(data){
    return request({
      url: 'org/Login/passwordLogin',
      method: 'post',
      data:data
    })
}

// 用户名或手机号登录--模拟卷
export function passwordLoginMockTest(data){
  return request({
    url: 'org/Login/passwordLoginMockTest',
    method: 'post',
    data:data
  })
}

// 获取验证码
export function sendVerificationCode(data){
    return request({
      url: 'api/login/sendVerificationCode',
      method: 'post',
      data:data
    })
}

// 找回密码
export function retrievePassword(data){
    return request({
      url: 'org/Login/retrievePassword',
      method: 'post',
      data:data
    })
}

// 退出登录
export function logout(token){
    return request({
      url: 'org/Login/logout',
      method: 'post',
      headers:{
        'userToken':token
      }
    })
}

// 获取所有机构
export function getOrgSelectList(data,token){
    return request({
      url: 'org/org/getOrgSelectList',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 机构列表
export function getOrgList(data,token){
    return request({
      url: 'org/org/getOrgList',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 添加机构
export function addOrg(data,token){
    return request({
      url: 'org/org/addOrg',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 获取编辑详情
export function getOrgDetail(data,token){
    return request({
      url: 'org/org/getOrgDetail',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 修改初始密码
export function updatePassword(data,token){
    return request({
      url: 'org/org/updatePassword',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 获取机构管理员列表
export function getOrgManageList(data,token){
    return request({
      url: 'org/org/getOrgManageList',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 删除机构管理员
export function delOrgManage(data,token){
    return request({
      url: 'org/org/delOrgManage',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 添加机构管理员
export function addOrgManage(data,token){
    return request({
      url: 'org/org/addOrgManage',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 证书类型列表
export function getCertTypeList(data,token){
    return request({
      url: 'org/Cert/getCertTypeList',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 证书类型添加/编辑
export function saveCertType(data,token){
    return request({
      url: 'org/Cert/saveCertType',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 证书列表
export function getCertList(data,token){
    return request({
      url: 'org/Cert/getCertList',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 获取证书选择列表
export function getSelectCertList(token){
    return request({
      url: 'org/Cert/getSelectCertList',
      method: 'post',
      headers:{
        'userToken':token
      }
    })
}

// 证书添加/编辑
export function saveCert(data,token){
    return request({
      url: 'org/Cert/saveCert',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 获取证书类型选择列表
export function getSelectCertTypeList(token){
    return request({
      url: 'org/Cert/getSelectCertTypeList',
      method: 'post',
      headers:{
        'userToken':token
      }
    })
}

// 证书发布状态修改
export function updateCertStatus(data,token){
    return request({
      url: 'org/Cert/updateCertStatus',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 学员列表
export function getStudentList(data,token){
    return request({
      url: 'org/student/getStudentList',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 学员添加/编辑
export function saveStudent(data,token){
    return request({
      url: 'org/student/saveStudent',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 获取学员详情
export function getStudentDetail(data,token){
    return request({
      url: 'org/student/getStudentDetail',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 删除学员
export function delStudent(data,token){
    return request({
      url: 'org/student/delStudent',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 证书下题目列表
export function getTopicList(data,token){
    return request({
      url: 'org/topic/getTopicList',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 题目添加/编辑
export function saveTopic(data,token){
    return request({
      url: 'org/topic/saveTopic',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 删除题目
export function delTopic(data,token){
    return request({
      url: 'org/topic/delTopic',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 批量删除
export function batchDelTopic(data,token){
    return request({
      url: 'org/topic/batchDelTopic',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 题目详情
export function getTopicDetail(data,token){
    return request({
      url: 'org/topic/getTopicDetail',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 习题设置 添加/编辑
export function saveExerSet(data,token){
    return request({
      url: 'org/Cert/saveExerSet',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 模拟卷设置 添加/编辑
export function saveTestSet(data,token){
    return request({
      url: 'org/Cert/saveTestSet',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 获取习题设置
export function getExerSet(data,token){
    return request({
      url: 'org/Cert/getExerSet',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 获取模拟卷设置
export function getTestSet(data,token){
    return request({
      url: 'org/Cert/getTestSet',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 角色添加
export function addRole(data,token){
    return request({
      url: 'org/account/addRole',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 角色删除
export function delRole(data,token){
    return request({
      url: 'org/account/delRole',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 获取角色列表
export function getRoleList(data,token){
    return request({
      url: 'org/account/getRoleList',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 获取角色权限
export function getRoleAuthority(data,token){
    return request({
      url: 'org/account/getRoleAuthority',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 设置角色权限
export function setRoleAuthority(data,token){
    return request({
      url: 'org/account/setRoleAuthority',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 管理员添加
export function addManage(data,token){
    return request({
      url: 'org/account/addManage',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 修改管理员
export function updateManage(data,token){
    return request({
      url: 'org/account/updateManage',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 管理员删除
export function delManage(data,token){
    return request({
      url: 'org/account/delManage',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 管理员列表
export function getManageList(data,token){
    return request({
      url: 'org/account/getManageList',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 获取角色选择列表
export function getLevelList(token){
    return request({
      url: 'org/account/getLevelList',
      method: 'post',
      headers:{
        'userToken':token
      }
    })
}

// 获取管理员权限
export function getManageAuthority(data,token){
    return request({
      url: 'org/account/getManageAuthority',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 设置管理员权限
export function setManageAuthority(data,token){
    return request({
      url: 'org/account/setManageAuthority',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 获取用户信息
export function getUserDetail(token){
    return request({
      url: 'org/account/getUserDetail',
      method: 'post',
      headers:{
        'userToken':token
      }
    })
}

// 修改用户名
export function updateUserName(data,token){
    return request({
      url: 'org/account/updateUserName',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 修改密码
export function accountUpdatePassword(data,token){
    return request({
      url: 'org/account/updatePassword',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 获取题目配置列表
export function getTopicSetList(token){
    return request({
      url: 'org/topic/getTopicSetList',
      method: 'post',
      headers:{
        'userToken':token
      }
    })
}

// 预览
export function preview(data,token){
    return request({
      url: 'org/topic/preview',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 学员导入
export function importStudent(data,token){
    return request({
      url: 'org/student/importStudent',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 获取已开启的配置
export function getOpenTopicSetList(token){
    return request({
      url: 'org/topic/getOpenTopicSetList',
      method: 'post',
      headers:{
        'userToken':token
      }
    })
}

// 题目配置
export function saveTopicSet(data,token){
    return request({
      url: 'org/topic/saveTopicSet',
      method: 'post',
      data:data,
      headers:{
        'userToken':token
      }
    })
}

// 提交
export function submitImport(data,token){
  return request({
    url: 'org/topic/submitImport',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取课程列表
export function getCourseList(data,token){
  return request({
    url: 'org/Course/getCourseList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取证书类型列表
export function getCertSetList(token){
  return request({
    url: 'org/Course/getCertSetList',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 获取证书列表
export function getCourseCertList(data,token){
  return request({
    url: 'org/Course/getCertList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑课程
export function saveCourse(data,token){
  return request({
    url: 'org/Course/saveCourse',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除课程
export function delCourse(data,token){
  return request({
    url: 'org/Course/delCourse',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 更改课程状态
export function updateCourseStatus(data,token){
  return request({
    url: 'org/Course/updateCourseStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取课程详情
export function getCourseDetail(data,token){
  return request({
    url: 'org/Course/getCourseDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑课件
export function saveCourseSub(data,token){
  return request({
    url: 'org/Course/saveCourseSub',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取课件列表
export function getCourseSubList(data,token){
  return request({
    url: 'org/Course/getCourseSubList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除课件
export function delCourseSub(data,token){
  return request({
    url: 'org/Course/delCourseSub',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取课件详情
export function getCourseSubDetail(data,token){
  return request({
    url: 'org/Course/getCourseSubDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取七牛云token

export function getUploadToken(token){
  return request({
    url: 'api/upload/getUploadToken',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 题目导入-word

export function importWordTopic(data,token){
  return request({
    url: 'org/topic/importWordTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取考试类型列表-模拟卷
export function getMockTestSetList(data,token){
  return request({
    url: 'org/MockTest/getMockTestSetList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑考试类型-模拟卷
export function saveMockTestSet(data,token){
  return request({
    url: 'org/MockTest/saveMockTestSet',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取题型配置列表-模拟卷
export function getTopicTypeList(data,token){
  return request({
    url: 'org/MockTest/getTopicTypeList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑题型配置-模拟卷
export function saveTopicType(data,token){
  return request({
    url: 'org/MockTest/saveTopicType',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取考试列表-模拟卷
export function getMockTestList(data,token){
  return request({
    url: 'org/MockTest/getMockTestList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑考试-模拟卷
export function saveMockTest(data,token){
  return request({
    url: 'org/MockTest/saveMockTest',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取考试类型选择列表-模拟卷
export function getSelectMockTestSetList(token){
  return request({
    url: 'org/MockTest/getSelectMockTestSetList',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 发布考试--模拟卷
export function publishMockTest(data,token){
  return request({
    url: 'org/MockTest/publishMockTest',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取老师列表--模拟卷
export function getTeacherList(data,token){
  return request({
    url: 'org/Personnel/getTeacherList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取考试选择列表--模拟卷
export function getSelectMockTestList(token){
  return request({
    url: 'org/MockTest/getSelectMockTestList',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑老师--模拟卷
export function saveTeacher(data,token){
  return request({
    url: 'org/Personnel/saveTeacher',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取老师详情--模拟卷
export function getTeacherDetail(data,token){
  return request({
    url: 'org/Personnel/getTeacherDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除老师--模拟卷
export function delTeacher(data,token){
  return request({
    url: 'org/Personnel/delTeacher',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取家长列表--模拟卷
export function getParentsList(data,token){
  return request({
    url: 'org/Personnel/getParentsList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑家长--模拟卷
export function saveParents(data,token){
  return request({
    url: 'org/Personnel/saveParents',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取家长详情--模拟卷
export function getParentsDetail(data,token){
  return request({
    url: 'org/Personnel/getParentsDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除家长--模拟卷
export function delParents(data,token){
  return request({
    url: 'org/Personnel/delParents',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取题库包列表--模拟卷
export function getQuebankPackageList(data,token){
  return request({
    url: 'org/MockTest/getQuebankPackageList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}


// 添加/编辑题库包--模拟卷
export function saveQuebankPackage(data,token){
  return request({
    url: 'org/MockTest/saveQuebankPackage',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除题库包--模拟卷
export function delQuebankPackage(data,token){
  return request({
    url: 'org/MockTest/delQuebankPackage',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取试卷列表--模拟卷
export function getTestList(data,token){
  return request({
    url: 'org/MockTest/getTestList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑试卷--模拟卷
export function saveTest(data,token){
  return request({
    url: 'org/MockTest/saveTest',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除试卷--模拟卷
export function delTest(data,token){
  return request({
    url: 'org/MockTest/delTest',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取考试题目类型--模拟卷
export function getMackTestTopicType(data,token){
  return request({
    url: 'org/MockTest/getMackTestTopicType',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 配置模拟卷--模拟卷
export function setTest(data,token){
  return request({
    url: 'org/MockTest/setTest',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 查看题目列表--模拟卷
export function getSubjectList(data,token){
  return request({
    url: 'org/MockTest/getTopicList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取题目模块--模拟卷
export function getTopicModel(data,token){
  return request({
    url: 'org/MockTest/getTopicModel',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 配置题目模块--模拟卷
export function setTopicModel(data,token){
  return request({
    url: 'org/MockTest/setTopicModel',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加题目--模拟卷
export function addTopic(data,token){
  return request({
    url: 'org/MockTest/addTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 查看题目列表--模拟卷
export function lookTopicList(data,token){
  return request({
    url: 'org/MockTest/getTopicList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 编辑小题目--模拟卷
export function editSmallTopic(data,token){
  return request({
    url: 'org/MockTest/editSmallTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}


// 获取模拟卷配置信息--模拟卷
export function getSetTestInfo(data,token){
  return request({
    url: 'org/MockTest/getSetTestInfo',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除题目--模拟卷
export function delTopics(data,token){
  return request({
    url: 'org/MockTest/delTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 上传文件
export function uploadFile(data){
  return request({
    url: '/ent/Upload/uploadFile',
    method: 'post',
    data:data,
  })
}

// 获取会员列表
export function getMockTestVipList(data,token){
  return request({
    url: 'org/MockTest/getMockTestVipList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//添加/编辑会员
export function saveMockTestVip(data,token){
  return request({
    url: 'org/MockTest/saveMockTestVip',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取包列表-不分页
export function getQuebankPackageFastList(token){
  return request({
    url: 'org/MockTest/getQuebankPackageFastList',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 获取考试列表--不分页
export function getTestFastList(data,token){
  return request({
    url: 'org/MockTest/getTestFastList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//获取会员详情
export function getMockTestVipDetail(data,token){
  return request({
    url: 'org/MockTest/getMockTestVipDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//删除会员
export function delMockTestVip(data,token){
  return request({
    url: 'org/MockTest/delMockTestVip',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//删除会员
export function editBigTopic(data,token){
  return request({
    url: 'org/MockTest/editBigTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//获取Banner列表
export function getBannerList(data,token){
  return request({
    url: 'org/Marketing/getBannerList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//添加/编辑Banner
export function saveBanner(data,token){
  return request({
    url: 'org/Marketing/saveBanner',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//更改Banner状态及排序
export function saveBannerStatus(data,token){
  return request({
    url: 'org/Marketing/saveBannerStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//删除Banner
export function delBanner(data,token){
  return request({
    url: 'org/Marketing/delBanner',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//获取练习模块列表
export function getExerModel(data,token){
  return request({
    url: 'org/MockTest/getExerModel',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//获取练习列表
export function getExerList(data,token){
  return request({
    url: 'org/MockTest/getExerList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//添加/编辑练习
export function saveExer(data,token){
  return request({
    url: 'org/MockTest/saveExer',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//删除练习
export function delExer(data,token){
  return request({
    url: 'org/MockTest/delExer',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//添加练习题目-听力单题
export function addExerTopic(data,token){
  return request({
    url: 'org/MockTest/addExerTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//获取练习题目列表
export function getExerTopicList(data,token){
  return request({
    url: 'org/MockTest/getExerTopicList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//编辑练习题
export function editExerTopic(data,token){
  return request({
    url: 'org/MockTest/editExerTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//删除练习题目
export function delExerTopic(data,token){
  return request({
    url: 'org/MockTest/delExerTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//编辑练习题音频
export function editExerTopicVideo(data,token){
  return request({
    url: 'org/MockTest/editExerTopicVideo',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//获取学生成绩列表
export function getChildrenResultList(data,token){
  return request({
    url: 'org/Personnel/getChildrenResultList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//获取学生成绩详情  
export function getChildrenResultDetail(data,token){
  return request({
    url: 'org/Personnel/getChildrenResultDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//添加题目配置  
export function addTopicSet(data,token){
  return request({
    url: 'org/topic/addTopicSet',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//获取案例题列表  
export function getBigTopicList(data,token){
  return request({
    url: 'org/topic/getBigTopicList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//添加题目-案例题  
export function addBigTopic(data,token){
  return request({
    url: 'org/topic/addBigTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//编辑题目-案例题
export function updateBigTopic(data,token){
  return request({
    url: 'org/topic/updateBigTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//获取意见反馈列表
export function getEvaluateList(data,token){
  return request({
    url: 'org/Marketing/getEvaluateList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

//获取vip列表（根据类型
export function getMockTestVipAllList(data,token){
  return request({
    url: 'org/MockTest/getMockTestVipAllList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}


// WEBPACK FOOTER //
// ./src/assets/js/api.js